import { render, staticRenderFns } from "./QuotationsPage.vue?vue&type=template&id=39b9690a"
import script from "./QuotationsPage.vue?vue&type=script&lang=js"
export * from "./QuotationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports